// extracted by mini-css-extract-plugin
export default {"body":"Search_body__YirQ6","header":"Search_header__HUs2J","gobackBox":"Search_gobackBox__dBx4K","inputBox":"Search_inputBox__4ZpkP"};